import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as glExpenses from '../../gl-expenses'

export const RESOURCE = {
  payload: {
    description:
      'A financial record documenting expenses within the institution’s general ledger system.',
    dimension: glExpenses.RESOURCE.payload,
    level: 0,
    name: 'GL Expense Entry',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
